import { HOTELS } from '../data.js';
import { state, priceFor, isFav } from '../state.js';
import { t, formatPriceParts } from '../i18n.js';

let suppressScroll = false;
let scrollTimer = null;
let onSelect = () => {};
let onBook = () => {};
let onDetails = () => {};
let onFav = () => {};

export function setHandlers({ onSelect: sel, onBook: book, onDetails: det, onFav: fav }) {
  if (sel) onSelect = sel;
  if (book) onBook = book;
  if (det) onDetails = det;
  if (fav) onFav = fav;
}

const heartSvg = (filled) =>
  `<svg viewBox="0 0 24 24" fill="${filled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 21s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.5-7 10-7 10z" />
  </svg>`;

export function buildCards() {
  state.filtered = HOTELS.map((_, i) => i)
    .filter((i) => HOTELS[i].city === state.city)
    .filter((i) => !state.showFavs || isFav(i));

  const wrap = document.getElementById('cards');

  if (state.filtered.length === 0) {
    wrap.innerHTML = `<div class="card-empty">
      <div class="empty-h">${t('card.empty.h', { city: state.city })}</div>
      <div class="empty-s">${t('card.empty.s')}</div>
      <button class="empty-cta" data-action="show-all">${t('card.empty.cta')}</button>
    </div>`;
    return;
  }

  wrap.innerHTML = state.filtered
    .map((i) => {
      const h = HOTELS[i];
      const p = priceFor(h);
      const hot = h.left <= 2;
      const hero = (h.pics && h.pics[0]) || '';
      const fav = isFav(i);
      const fp = formatPriceParts(p.now);
      const fpWas = p.was != null ? formatPriceParts(p.was) : null;
      const priceBlock =
        state.mode === 'night'
          ? `<div class="cnow">${fp.num} <span>${fp.unit}</span></div>
             <div class="cwas"><s>${fpWas.num} ${fpWas.unit}</s><span class="off">−${p.off}%</span></div>`
          : `<div class="cnow">${fp.num} <span>${fp.unit}</span></div>
             <div class="cwas">${t('card.dayblock', { n: state.hours })}</div>`;
      return `<div class="card" data-i="${i}">
        <div class="chero">
          ${
            hero
              ? `<img src="${hero}" alt="${h.nm}" loading="lazy" decoding="async" />`
              : ''
          }
          <button class="cfav${fav ? ' on' : ''}" data-fav="${i}" aria-label="${fav ? 'Remove from saved' : 'Save for later'}" aria-pressed="${fav}">
            ${heartSvg(fav)}
          </button>
          <span class="cleft${hot ? ' hot' : ''}">${t('card.left', { n: h.left })}</span>
        </div>
        <div class="cbody">
          <div class="crow">
            <div>
              <div class="cnm">${h.nm}</div>
              <div class="cmeta">${h.area} · ${'★'.repeat(h.st)}</div>
            </div>
          </div>
          <div class="cwin">${
            state.mode === 'night'
              ? t('card.window.night')
              : t('card.window.day', { win: h.win })
          }</div>
          <div class="cfoot">
            <div class="cprice">${priceBlock}</div>
            <button class="cbook" data-book="${i}">${t('card.book')}</button>
          </div>
        </div>
      </div>`;
    })
    .join('');
}

export function updateHeart(i) {
  const fav = isFav(i);
  const btn = document.querySelector(`.card[data-i="${i}"] .cfav`);
  if (btn) {
    btn.classList.toggle('on', fav);
    btn.setAttribute('aria-pressed', String(fav));
    btn.setAttribute('aria-label', fav ? 'Remove from saved' : 'Save for later');
    btn.innerHTML = heartSvg(fav);
  }
  const dbtn = document.getElementById('detailHeart');
  if (dbtn && +dbtn.dataset.i === i) {
    dbtn.classList.toggle('on', fav);
    dbtn.setAttribute('aria-pressed', String(fav));
    dbtn.innerHTML = heartSvg(fav);
  }
}

export function centerCardOn(i) {
  const card = document.querySelector(`.card[data-i="${i}"]`);
  if (!card) return;
  suppressScroll = true;
  card.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  clearTimeout(scrollTimer);
  scrollTimer = setTimeout(() => (suppressScroll = false), 500);
}

function centeredCardIndex() {
  const wrap = document.getElementById('cards');
  const mid = wrap.scrollLeft + wrap.clientWidth / 2;
  let best = null;
  let bd = Infinity;
  wrap.querySelectorAll('.card').forEach((c) => {
    const cm = c.offsetLeft + c.offsetWidth / 2;
    const d = Math.abs(cm - mid);
    if (d < bd) {
      bd = d;
      best = +c.dataset.i;
    }
  });
  return best;
}

export function bindCards() {
  const wrap = document.getElementById('cards');
  wrap.addEventListener('scroll', () => {
    if (suppressScroll) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const i = centeredCardIndex();
      if (i != null && i !== state.sel) onSelect(i, false);
    }, 90);
  });
  wrap.addEventListener('click', (e) => {
    const fv = e.target.closest('[data-fav]');
    if (fv) {
      e.stopPropagation();
      onFav(+fv.dataset.fav);
      return;
    }
    const empty = e.target.closest('[data-action="show-all"]');
    if (empty) {
      onFav(-1); // signal: clear filter
      return;
    }
    const bk = e.target.closest('[data-book]');
    if (bk) {
      onBook(+bk.dataset.book);
      return;
    }
    const c = e.target.closest('[data-i]');
    if (c) onDetails(+c.dataset.i);
  });
}

export function resetScroll() {
  document.getElementById('cards').scrollLeft = 0;
}
